import MODEL_CONFIG from './modelConfig.graphql'
import SYNC_HIERARCHY from './syncHierarchy.graphql'
import IMAGE_FRAGMENT from './ImageFragment.graphql'
import IMAGE_WRAPPER_FRAGMENT from './ImageWrapperFragment.graphql'
import SYNC_PLAN from './syncPlan.graphql'
import SYNC_DEV_HIERARCHY from './syncDevHierarchy.graphql'
import SYNC_SUBSCRIPTION from './syncSubscription.graphql'
import INCREMENTAL_SYNC from './incrementalSync.graphql'
import CREATE_CATALOG_ITEM  from './createCatalogItem.graphql'
import ASSIGN_ITEM_TO from './assignTo.graphql'
import UPDATE_DATABASE_CONFIG from './databaseConfigUpdate.graphql'

import {CREATE_COMMENT_ES, GET_COMMENT_ES} from './comment'
import IMAGE_OPERATION from './imageOperations.graphql'
import REORDER_IMAGES_OPERATION from './reorderImagesOperations.graphql'
import DELETE_CATALOGITEM from './deleteCatalogItem.graphql'
import MERCH_SECONDARY_VERSIONS from './sidebar/plmMerchSecondaryVersions.graphql'
export {
  IMAGE_FRAGMENT, IMAGE_WRAPPER_FRAGMENT,
  SYNC_HIERARCHY, SYNC_PLAN, MODEL_CONFIG, INCREMENTAL_SYNC,
  SYNC_SUBSCRIPTION, SYNC_DEV_HIERARCHY, CREATE_COMMENT_ES, GET_COMMENT_ES,
  CREATE_CATALOG_ITEM, ASSIGN_ITEM_TO, IMAGE_OPERATION, REORDER_IMAGES_OPERATION,
  DELETE_CATALOGITEM, UPDATE_DATABASE_CONFIG, MERCH_SECONDARY_VERSIONS
}

export const UNASSIGNED = 'unassigned'

export * from './models'
export * from './apolloClientCache'
export * from './activities'
export * from './configuration'
export * from './notes'
export * from './plmColor'
export * from './plmMaterial'
export * from './tags'

import * as apolloCache from './apolloClientCache'

export {apolloCache}

export * from './shortener'


// WEBPACK FOOTER //
// ./src/modules/common/graphql/index.ts